import { api } from '@/lib/api'
import type { ApiResponse } from '../profile/types'
import type { SlotMachineConfig, SlotMachineStats, SpinResult, SlotMachineHistory } from './types'

export async function getSlotMachineStatus(): Promise<ApiResponse<SlotMachineStats>> {
  const res = await api.get('/api/user/slot-machine/status')
  return res.data
}

export async function performSpin(): Promise<ApiResponse<SpinResult>> {
  const res = await api.post('/api/user/slot-machine/spin')
  return res.data
}

export async function getSlotMachineHistory(page = 1, pageSize = 20): Promise<ApiResponse<SlotMachineHistory>> {
  const res = await api.get(`/api/user/slot-machine/history?page=${page}&page_size=${pageSize}`)
  return res.data
}

export async function getSlotMachineConfig(): Promise<ApiResponse<SlotMachineConfig>> {
  const res = await api.get('/api/user/slot-machine/config')
  return res.data
}
